import { Component, OnInit } from '@angular/core';
import { RegService } from '../shared/Reg.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  public step = 'one';
  public data: any;

  constructor(private regService: RegService, private appInsightsService: AppInsightsService) { }

  ngOnInit() {
    this.appInsightsService.logPageView("Employee Registration UI Page View");
    this.regService.checkDfa().subscribe(resp => {
      this.data = resp;
      if (this.data && this.data.dfaCompleted === 'Y') {
        this.step = 'two';
      } else if (this.data && this.data.EBDualUser === 'Y') {
        this.step = 'EBDualUser';
      }
    });
  }

  handleExistingUserContinue() {
    this.regService.loadData().subscribe((resp: any) => {
      if (resp && resp.url) {
        window.location.href = resp.url;
      }
    });
  }

  updateStep(data) {
    if (data === 'login') {
      this.handleExistingUserContinue();
      return;
    }
    this.step = data;
    console.log('new step: ' + this.step);
  }

}

